<template>
    <div class="flex flex-col gap-4">
        Not value
    </div>
</template>
<script lang="ts" setup></script>
